import * as React from 'react';
import { useIntl } from 'react-intl';
import * as EmployeeService from './EmployeeService';
import ConfirmDialog from '../ConfirmDialog';
import { IEmployeeConfrimDialog } from './interfaces';
import LoaderService from '../../Services/LoaderService';

function UnBlockUser(props: IEmployeeConfrimDialog): JSX.Element {
  const { formatMessage: f } = useIntl();

  const handleSubmitMultipleReactiveConfirmDialog = async (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    event.preventDefault();
    LoaderService.showLoader();
    const res = await EmployeeService.reactivateMultiple(props.selectedIds);
    if (res) {
      props.updateTable();
      props.handleConfirmDialogOpen(false);
    }
    LoaderService.showLoader(false);
  };

  const handleSubmitReactiveConfirmDialog = async (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    event.preventDefault();
    LoaderService.showLoader();
    const res = await EmployeeService.reactivate(props.selectedIds[0]);
    if (res) {
      props.updateTable();
      props.handleConfirmDialogOpen(false);
    }
    LoaderService.showLoader(false);
  };

  const closeConfirmDialog = () => {
    props.handleConfirmDialogOpen(false);
  };

  return props.selectedIds.length > 1 ? (
    <ConfirmDialog
      title={`${f({ id: 'employee.confirm.dialog.multiple.unblock.title' })}`}
      cancelCallback={closeConfirmDialog}
      continueCallback={handleSubmitMultipleReactiveConfirmDialog}
      cancelButtonTitle={f({
        id: 'form.cancel',
      })}
      continueButtonTitle={f({
        id: 'table_list.actions.unblock',
      })}
    >
      {f(
        { id: 'table.confirm.dialog.multiple.unblock.message' },
        { count: props.selectedIds.length }
      )}
    </ConfirmDialog>
  ) : (
    <ConfirmDialog
      title={`${f({ id: 'employee.confirm.dialog.unblock.title' })}`}
      cancelCallback={closeConfirmDialog}
      continueCallback={handleSubmitReactiveConfirmDialog}
      cancelButtonTitle={f({
        id: 'form.cancel',
      })}
      continueButtonTitle={f({
        id: 'table_list.actions.unblock',
      })}
    >
      {f(
        { id: 'table.confirm.dialog.unblock.message' },
        {
          name: `${props.fullname}`,
        }
      )}
    </ConfirmDialog>
  );
}

export default UnBlockUser;
